import { AvField, AvForm } from "availity-reactstrap-validation";
import { withNamespaces } from "react-i18next";
import { Col, Label, Row } from "reactstrap";
import ButtonsGroup from "../ButtonsGroup";

const NotObliged = ({ t, onValidSubmit, onBackClicked, prevData }) => {
    return (
        <AvForm 
            onValidSubmit={(_e, values) => {
                onValidSubmit(values)
            }} 
            className="needs-validation"
        >
            <Row>
                <Col sm='12' md='6'>
                    <Label for="ddsNotes">
                        {t('Justification')} <span className="text-danger">*</span>
                    </Label>
                    <AvField
                        name="ddsNotes"
                        type="text"
                        errorMessage={t("This field cannot be blank")}
                        className="form-control"
                        validate={{
                            required: { value: true }
                        }}
                        id="ddsNotes"
                        defaultValue={prevData?.ddsNotes}
                    />
                </Col>
            </Row>

            <ButtonsGroup
                onBackClicked={onBackClicked}
                onNextClicked={() => { }}
                nextButtonType='submit'
            />
        </AvForm>
    )
};

export default withNamespaces()(
    NotObliged
);